/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-04-16T10:11:30.177
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import BasicLayout from '@/layouts/basic-layout';

const meta = {
auth: true
};

const pre = 'rentmanage-rentbusinessarea-'

export default 
{
path: '/rentmanage/rentbusinessarea',
name: 'rentmanage-rentbusinessarea',
redirect: {
name: '${pre}-index'
}
,

meta:{
...meta,
},

component: BasicLayout ,
children:
[
{
path: 'index',
name: '${pre}rentbusinessarea-index',

meta:{
...meta,
title: '商圈管理'
},

component: () => import('@/pages/rentmanage/rentbusinessarea/index') ,
},
{
path: 'detail-edit/:id',
name: '${pre}rentbusinessarea-detail-edit',
auth: [
'hidden'
],

meta:{
...meta,
title: '商圈管理编辑'
},

component: () => import('@/pages/rentmanage/rentbusinessarea/detail-edit') ,
},
{
path: 'detail-edit',
name: '${pre}rentbusinessareadetail-create',
auth: [
'hidden'
],

meta:{
...meta,
title: '商圈管理新增'
},

component: () => import('@/pages/rentmanage/rentbusinessarea/detail-edit') ,
},
{
path: 'detail-view/:id',
name: '${pre}rentbusinessareaView',
auth: [
'hidden'
],

meta:{
...meta,
title: '商圈管理详情查看'
},

component: () => import('@/pages/rentmanage/rentbusinessarea/detail-view') ,
},
]
};
